import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-vervoersvoorziening',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconVervoersvoorziening {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M9.66 27h3.15a6.483 6.483 0 0 1-7.43 4.94C2.73 31.49.58 29.35.13 26.7A6.494 6.494 0 0 1 5 19.27v3.17a3.479 3.479 0 0 0-1.88 3.92 3.46 3.46 0 0 0 2.59 2.58c1.73.39 3.3-.53 3.95-1.95Zm-.15-13.5c1.38 0 2.51-1.12 2.51-2.51S10.9 8.48 9.51 8.48 7 9.6 7 10.99s1.12 2.51 2.51 2.51m5.82 8.5H12v-4.18c0-1.17-.74-2.28-1.88-2.55-1.65-.4-3.12.85-3.12 2.43v4.79C7 23.87 8.13 25 9.51 25H15v7h3v-7.33C18 23.2 16.8 22 15.33 22M33 20h3v-9.91l-1.99-6.03c-.44-1.23-1.64-2.06-3-2.06h-8.96c-1.36 0-2.56.83-3 2.08l-2.04 6.01V20h3v-3h13v3ZM21.74 5h9.47l1.23 4H20.5zm.26 8h-2v-2h2zm11 0h-2v-2h2z"/>
</svg>

    );
  }
}
